import Vue from 'vue';

export default class EventBus {
  constructor(logger) {
    this.EVENT_ACCOUNT_LOCKED = 'account_locked';
    this.EVENT_BAD_SOURCE_CREDENTIALS = 'bad_source_credentials';
    this.EVENT_IMPORT_COMPLETE = 'import_complete';
    this.EVENT_IMPORT_PROGRESS = 'import_progress';
    this.EVENT_MEMBER_UPDATED = 'member_updated';
    this.EVENT_NEW_IMPORT_FOUND = 'new_import_found';
    this.EVENT_PASSWORD_RESET_REQUIRED = 'password_reset_required';
    this.EVENT_POST_IMPORT_CALCULATIONS_COMPLETE = 'post_import_calculations_complete';
    this.EVENT_POST_IMPORT_CALCULATIONS_PROGRESS = 'post_import_calculations_progress';
    this.EVENT_PULLER_FAILED = 'puller_failed';
    this.EVENT_CALENDAR_UPDATED = 'calendar_updated';

    window.addEventListener('emptyAppleImportDetected', (e) => {
      this.bus.$emit(e);
    });

    this.logger = logger;
    this.bus = new Vue();
  }

  emit(event, ...args) {
    this.logger.log('Emitting event', event, ...args);
    this.bus.$emit(event, ...args);
  }

  on(event, callback) {
    this.logger.log('Adding event listener', event);
    this.bus.$on(event, callback);
  }

  off(event, callback) {
    this.logger.log('Removing event listener', event);
    this.bus.$off(event, callback);
  }

  once(event, callback) {
    this.logger.log('Adding event listener once', event);
    this.bus.$once(event, callback);
  }
}
